import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--color-icon)",
      "stroke-miterlimit": "10",
      d: "M10.125 21.375a2.25 2.25 0 0 0 4.5 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "var(--color-icon)",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      d: "M22.125 19.125s-2.25-3.75-2.25-6.75v-3.75a7.5 7.5 0 0 0-15 0v3.75c0 3-2.25 6.75-2.25 6.75z"
    }, null, -1)
  ]))]))
}
export default { render: render }